function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__a",
  x1: "34.814%",
  x2: "87.66%",
  y1: "27.816%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__b",
  x1: "39.837%",
  x2: "87.33%",
  y1: "33.027%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__c",
  x1: "-.214%",
  x2: "100.321%",
  y1: "50.263%",
  y2: "50.263%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4543C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "24%",
  stopColor: "#F45D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#F67755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "73%",
  stopColor: "#F67D5A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__d",
  x1: "36.387%",
  x2: "100%",
  y1: "42.178%",
  y2: "73.041%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__e",
  x1: "35.911%",
  x2: "84.939%",
  y1: "27.816%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "trusted-illustration_svg__f",
  x1: ".005%",
  x2: "99.891%",
  y1: "50.047%",
  y2: "50.047%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4543C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "24%",
  stopColor: "#F45D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#F67755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "73%",
  stopColor: "#F67D5A"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.855)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFEFDB",
  d: "M101.553 35.658c20.51 4.736 17.622 44.929-6.305 47.901-51.665 6.417 1.573 1.2-34.902 0-40.122-1.32-42.257 22.604-56.124-23.879-13.868-46.482 8.295-44.49 39.292-42.04 10.064.794 30.412-.583 40.006 2.624 5.793 1.936 11.414-7.875 12.264-1.712.85 6.163-14.741 12.37 5.769 17.106z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 100.731,
  cy: 89.573,
  fill: "#F1823B",
  fillRule: "nonzero",
  rx: 3.106,
  ry: 3.121
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 111.603,
  cy: 76.87,
  fill: "#FDB913",
  fillRule: "nonzero",
  rx: 4.66,
  ry: 4.681
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  fillRule: "nonzero",
  d: "M7.843 5.177l2.8-2.812a1.13 1.13 0 011.6 0l2.8 2.812a1.13 1.13 0 010 1.594l-2.8 2.812a1.13 1.13 0 01-1.6 0l-2.8-2.812a1.13 1.13 0 010-1.594z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE9824",
  d: "M123.652 2.054l1.875 4.333 4 2.219a.936.936 0 01.001 1.636l-4.001 2.229-1.704 4.27a.936.936 0 01-1.714.058l-1.926-4.023-4.203-2.35a.936.936 0 01-.008-1.63l4.21-2.409 1.743-4.312a.936.936 0 011.727-.02zM12.292 81.018l.676 1.561 1.625.901a.936.936 0 01.001 1.637l-1.626.906-.621 1.556a.936.936 0 01-1.714.057l-.69-1.44-1.752-.98a.936.936 0 01-.008-1.63l1.76-1.007.622-1.54a.936.936 0 011.727-.02z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#trusted-illustration_svg__a)",
  d: "M55.749 0c-.74 0-1.443.323-1.927.885-13.324 15.386-24.16 20.4-39.564 24.17a2.562 2.562 0 00-1.901 2.487c0 18.195 3.828 35.12 10.592 47.84C30.671 89.754 41.902 98.268 55.43 100h.639c11.678-1.5 21.811-8.168 29.354-19.31 6.713-10.001 11.192-23.35 12.953-38.608.538-4.827.793-9.682.766-14.54a2.562 2.562 0 00-1.94-2.487c-12.647-3.103-21.032-7.053-28.958-13.618A89.865 89.865 0 0157.676.86 2.548 2.548 0 0055.749 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#trusted-illustration_svg__b)",
  d: "M55.621 87.438c-22.268-2.857-32.23-29.525-32.23-54.696a.984.984 0 01.745-.985c11.766-2.867 20.523-6.896 30.868-18.875a.979.979 0 011.49 0 68.7 68.7 0 008.237 8.226c6.207 5.152 12.747 8.235 22.631 10.659a.984.984 0 01.745.985c.003 3.68-.21 7.358-.637 11.014-2.893 25.16-14.708 41.465-31.594 43.632h-.255v.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#trusted-illustration_svg__c)",
  fillRule: "nonzero",
  d: "M38.317 49.711h8.099v14.936h-8.099z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#trusted-illustration_svg__d)",
  d: "M41.201 59.854h1.886c.666 0 1.11.446 1.11 1.114v.558c0 .668-.444 1.114-1.11 1.114h-1.886c-.666 0-1.11-.446-1.11-1.114v-.558c0-.668.555-1.114 1.11-1.114z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#trusted-illustration_svg__e)",
  d: "M46.415 49.71s9.32-10.03 8.543-14.935c-.555-3.12 1.775-5.127 5.325-2.006 4.548 4.013.998 10.477.998 10.477h11.982c1.22 1.672.998 3.901-.444 5.35 2.33 1.115 1.775 4.904-.998 5.462 1.442 1.449.887 5.238-2.108 6.242.776 2.563-.666 4.235-3.883 4.235H46.415V49.711z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 95.784,
  cy: 27.865,
  fill: "url(#trusted-illustration_svg__f)",
  fillRule: "nonzero",
  rx: 16.752,
  ry: 16.83
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.344,
  d: "M90.015 28.422l3.328 3.901 8.21-8.917"
}));

function SvgTrustedIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 100
  }, props), _ref, _ref2);
}

export default SvgTrustedIllustration;